import Vue from "vue"
import Vuex from "vuex"
import Lockr from "lockr"

Vue.use(Vuex)

let token = Lockr.get("cop_token")
let username = Lockr.get("cop_username")
let promo = Lockr.get("cop_promo")

export default new Vuex.Store({
  state: {
    token,
    username,
    promo,
  },
  mutations: {
    setToken(state, token) {
      Lockr.set("cop_token", token)
      if (!token) Lockr.rm("cop_token")
      state.token = token
    },
    setUsername(state, username) {
      Lockr.set("cop_username", username)
      state.username = username
    },
    setPromo(state, promo) {
      Lockr.set("cop_proma", promo)
      state.promo = promo
    },
    clean(state) {
      Lockr.rm("cop_token")
      Lockr.rm("cop_username")
      Lockr.rm("cop_promo")
      state.username = undefined
      state.token = undefined
      state.promo = undefined
    },
  },
  actions: {},
  modules: {},
})
